import React, { useState, useEffect } from 'react';
import api from "~/services/api";

import { Container, ThisCard, ThisCardAnalista, ScrollOS } from './styles';
import * as XLSX from 'xlsx';

import IconePdf from '~/assets/icones/IconePdf.svg';
import IconeExcel from '~/assets/icones/IconeExcel.svg';
import IconAnoFechamento from '~/assets/icones/anoFechamento.svg';
import IconMesFechamento from '~/assets/icones/mesFechamento.svg';
import IconResponsavelFechamento from '~/assets/icones/responsavelFechamento.svg';
import IconHorasFechamento from '~/assets/icones/horasFechamento.svg';

import IconePdfB from '~/assets/icones/IconePdfB.svg';
import IconeExcelB from '~/assets/icones/IconeExcelB.svg';
import IconAnoFechamentoB from '~/assets/icones/anoFechamentoB.svg';
import IconMesFechamentoB from '~/assets/icones/mesFechamentoB.svg';
import IconResponsavelFechamentoB from '~/assets/icones/responsavelFechamentoB.svg';
import IconHorasFechamentoB from '~/assets/icones/horasFechamentoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [dados, setDados] = useState([]);
  const [dadosAbertos, setDadosAbertos] = useState([]);
  const [ordensServicos, setOrdensServicos] = useState([]);
  const [geraExcel, setGeraExcel] = useState(false);
  const [idFechamentoOS, setIdFechamentoOS] = useState();
  const [idFechamentoOSAnalista, setIdFechamentoOSAnalista] = useState();

  useEffect(() => {
    if (geraExcel === true) {
      api.get("/signed/empresa/gestorprojeto/fechamento/ordensservicos/excel", { params: { idFechamentoOS, idFechamentoOSAnalista } })
        .then(response => setOrdensServicos(response.data));
    }
  }, [geraExcel]);

  useEffect(() => {
    if (geraExcel === true) {
      setGeraExcel(false);

      let dados = [];
      for (const item of ordensServicos) {
        dados.push({
          "Id OS": "#" + item?.id,
          "Titulo": item?.titulo,
          "Fechamento": item?.fechamentoOS?.titulo,
          "Data Emissão": ((new Date(item?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
          "Data Fechamento": ((new Date(item?.dataFechamento).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
          "Cliente": item?.cliente?.nomeFantasia,
          "Coordenador": item?.coordenador?.nome,
          "Coordenador Tec": item?.coordenador?.nome,
          "Projeto": item?.projeto?.titulo,
          "Horas Apontada": item?.horaApontada,
          "Horas Desconto": item?.horaDesconto,
          "Horas Translado": item?.horaTranslado,
          "Horas Total": item?.horaTotal,
        });
      }

      const worksheet = XLSX.utils.json_to_sheet(dados);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ordens de Serviços");
      XLSX.writeFile(workbook, "Fechamento OS" + (new Date().toLocaleString('pt-BR', { timeZone: 'UTC' })) + ".xlsx");
    }
  }, [ordensServicos]);

  useEffect(() => {
    let lista = [];
    for (const item of data) {
      let findIndex = dadosAbertos.findIndex((e) => e?.id == item?.id);

      lista.push({
        ...item,
        aberto: findIndex < 0 ? false : true,
      });
    }

    setDados(lista);
  }, [data]);

  return (
    <Container>
      <div className="content-os">
        <ScrollOS>
          {dados?.map((thisData, i) => (
            <div className="fechamento">
              <ThisCard
                className={
                  linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
                }
                {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                key={thisData?.id || i}
                id={thisData?.id || i}
                index={i}
                ativo={linhaAtiva === thisData?.id ? true : false}
                corBackground={thisData?.corStatusAprov}
                onClick={() => {
                  let lista = [];
                  let listaAbertos = [];

                  for (const itemAtivo of dados) {
                    if (itemAtivo?.id == thisData?.id) {
                      lista.push({ ...itemAtivo, aberto: !itemAtivo?.aberto });

                      if (!itemAtivo?.aberto) {
                        listaAbertos.push({ ...itemAtivo, aberto: true });
                      }
                    } else {
                      lista.push(itemAtivo);
                    }
                  }

                  setDados(lista);
                  setDadosAbertos(listaAbertos);
                }}
              >
                <div className="top">
                  <div className="content-top">
                    <div className="card-top">
                      <p className="titulo">#{thisData?.id} - {thisData?.titulo}</p>
                      <p className="analista">Fechamento de Ordem de Serviço</p>
                    </div>
                  </div>
                  <div className="info">
                    <p className="data">{((new Date(thisData?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                  </div>
                </div>
                <div className="content-os">
                  <div className="left">
                    <div className="horario">
                      <div className="item-hora">
                        <div className="card-numero">
                          <p className="numero"><img src={localStorage.getItem("tema") == "E" ? IconAnoFechamento : IconAnoFechamentoB} alt="Vazio" /></p>
                        </div>
                        <div className="card-hora">
                          <p className="hora">Mês/Ano: {thisData?.mesFechamentoMascara}/{thisData?.anoFechamento}</p>
                        </div>
                      </div>
                      <div className="item-hora">
                        <div className="card-numero">
                          <p className="numero"><img src={localStorage.getItem("tema") == "E" ? IconResponsavelFechamento : IconResponsavelFechamentoB} alt="Vazio" /></p>
                        </div>
                        <div className="card-hora">
                          <p className="hora">Total Horas: {thisData?.horaTotal}h</p>
                        </div>
                      </div>
                      <div className="item-hora">
                        <div className="card-numero">
                          <p className="numero"><img src={localStorage.getItem("tema") == "E" ? IconHorasFechamento : IconHorasFechamentoB} alt="Vazio" /></p>
                        </div>
                        <div className="card-hora">
                          <p className="hora">Responsável: {thisData?.perfil?.usuario?.nome}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="acao">
                      <img
                        src={localStorage.getItem("tema") == "E" ? IconeExcel : IconeExcelB}
                        alt="Vazio"
                        onClick={(e) => {
                          e.stopPropagation();

                          setGeraExcel(true);
                          setIdFechamentoOS(thisData?.id);
                          setIdFechamentoOSAnalista(undefined);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </ThisCard>
              {thisData?.aberto &&
                <div className="fec-analista">
                  {thisData?.analistas?.map((thisDataAnal, o) => (
                    <ThisCardAnalista
                      className={
                        linhaAtiva === thisDataAnal?.id ? 'card-item ativo' : 'card-item'
                      }
                      {...{ data: thisDataAnal, linhaAtiva, setLinhaAtiva }}
                      key={thisDataAnal?.id || o}
                      id={thisDataAnal?.id || o}
                      index={o}
                      ativo={linhaAtiva === thisDataAnal?.id ? true : false}
                      corBackground={thisDataAnal?.corStatusAprov}
                    >
                      <div className="img-perfil">
                        <img src={localStorage.getItem("tema") == "E" ? IconResponsavelFechamento : IconResponsavelFechamentoB} alt="Vazio" />
                      </div>
                      <div className="content-perfil">
                        <div className="top">
                          <div className="content-top">
                            <div className="card-top">
                              <p className="titulo">{thisDataAnal?.titulo}</p>
                              <p className="analista">Fechamento de Ordem de Serviço P/ Analista</p>
                            </div>
                          </div>
                          <div className="info">
                            <p className="data"></p>
                          </div>
                        </div>
                        <div className="content-os">
                          <div className="left">
                            <div className="horario">
                              <div className="item-hora">
                                <div className="card-numero">
                                  <p className="numero">
                                    <img src={localStorage.getItem("tema") == "E" ? IconAnoFechamento : IconAnoFechamentoB} alt="Vazio" />
                                  </p>
                                </div>
                                <div className="card-hora">
                                  <p className="hora">Mês/Ano: {thisDataAnal?.mesFechamentoMascara}/{thisDataAnal?.anoFechamento}</p>
                                </div>
                              </div>
                              <div className="item-hora">
                                <div className="card-numero">
                                  <p className="numero">
                                    <img src={localStorage.getItem("tema") == "E" ? IconResponsavelFechamento : IconResponsavelFechamentoB} alt="Vazio" />
                                  </p>
                                </div>
                                <div className="card-hora">
                                  <p className="hora">Analista: {thisDataAnal?.analista?.nome}</p>
                                </div>
                              </div>
                              <div className="item-hora">
                                <div className="card-numero">
                                  <p className="numero">
                                    <img src={localStorage.getItem("tema") == "E" ? IconHorasFechamento : IconHorasFechamentoB} alt="Vazio" />
                                  </p>
                                </div>
                                <div className="card-hora">
                                  <p className="hora">Total Horas: {thisDataAnal?.horaTotal}h</p>
                                </div>
                              </div>
                              <div className="item-hora">
                                <div className="card-numero">
                                  <p className="numero">
                                    <img src={localStorage.getItem("tema") == "E" ? IconMesFechamento : IconMesFechamentoB} alt="Vazio" />
                                  </p>
                                </div>
                                <div className="card-hora">
                                  <p className="hora">Data Emissão: {((new Date(thisDataAnal?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="right">
                            <div className="acao">
                              <img
                                src={localStorage.getItem("tema") == "E" ? IconeExcel : IconeExcelB}
                                alt="Vazio"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  setGeraExcel(true);
                                  setIdFechamentoOS(thisData?.id);
                                  setIdFechamentoOSAnalista(thisDataAnal?.id);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </ThisCardAnalista>
                  ))}
                </div>
              }
            </div>
          ))}
        </ScrollOS>
      </div>
    </Container>
  );
}

export default CustomBodyContent;
